import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopPremiumContent from './ShopPremiumContent';

export const getShopPremiumContentWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: ShopPremiumContent,
});
